module.exports = __webpack_public_path__ + "5b8eadc15a97b339e6a579bc96a67c78.png";